import React, { Suspense } from 'react';
import { Waypoint } from 'react-waypoint';
import qs from 'qs';
import { observer } from 'mobx-react';

import callApi from '../../utils/callApi';
import LockedVideo from '../../components/videoComponents/LockedVideo';
import PromoSection from '../../components/promoComponents/PromoSection';
import FixedVideo from '../../components/promoComponents/FixedPromoVideo';
import { ARHIVE_LIST } from '../../constants/apiUrls/apiUrls';
import { PROMO_CODES } from '../../constants/promoCodes';
import { getCookie } from '../../utils/helpers';
import CoRegModal from '../../components/generalComponents/CoRegModal';
import CampaignStore from '../../store/CampaignStore';
import FeaturedSection from '../../components/featuredComponents/FeaturedSection';
import VideoPlayer from '../../components/videoComponents/VideoPlayer';


const NAKED_NEWS_LIVE_ID = 241;
@observer
class HomePage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lastSegment: null,
      displayFixedVideo: false,
      showCoRegModal: false,
    };
  }

  componentDidMount() {
    const canonicalTag = document.createElement('link');
    canonicalTag.setAttribute('rel', 'canonical');
    canonicalTag.setAttribute('href', 'https://nakednews.com');

    document.head.appendChild(canonicalTag);
    document.title = 'Home | Naked News is an adult news and entertainment program, with a gorgeous cast of anchors, where the facts aren\'t the only thing stripped down.';

    const {
      location: { search },
      user: { authenticated },
    } = this.props;
    const params = qs.parse(search, { ignoreQueryPrefix: true });

    if (params._atc === PROMO_CODES.CAM4_SOURCE && !authenticated) {
      this.setState({ showCoRegModal: true });
    }

    const baseUrl = ARHIVE_LIST;
    const parsedUrl = baseUrl.replace('{page}', 1).replace('{size}', 1);
    callApi(parsedUrl, 'get', {}).then((res) => {
      this.setState({ lastSegment: res.data.segments[0] });
    });
  }

  hideFixedVideo = () => {
    this.setState({ displayFixedVideo: false });
  };

  displayFixedVideo = () => {
    sessionStorage.getItem('HIDE_FIXED_VIDEO') ? this.setState({ displayFixedVideo: false }) : this.setState({ displayFixedVideo: true });
  };

  videoControl = (e) => {
    if (!e.target.hasAttribute('href')) {
      e.preventDefault();
    }
  };

  isCampaignActive = (currentCampaign) => {
    const { user } = this.props;
    const { affiliateCode } = currentCampaign || {};
    const hasActiveMembership = user?.user?.activeSubscription;

    return user?.features?.includes(affiliateCode) && !hasActiveMembership;
  };

  render() {
    const { user, history, location } = this.props;
    const {
      lastSegment,
      displayFixedVideo,
      showCoRegModal,
    } = this.state;

    const hasAtc = getCookie('_atc');
    const promoBlockedByAtc =
      hasAtc && (hasAtc === PROMO_CODES.CAM4_SOURCE);
    const isAnchor =
      user && user.user && user.user.username && user.user.account.anchor;

    // Subscription check
    const isSubscriptionExpired =
      user.authenticated && !user.user.activeSubscription;

    const { campaignToShowOnHomePage } = CampaignStore;
    const { videoImage, mainImage, mainMobileImage, backgroundColor, checkoutUrl } = campaignToShowOnHomePage || {};

    const campaignIsActive = this.isCampaignActive(campaignToShowOnHomePage);

    return (
      <React.Fragment>
        {!promoBlockedByAtc
          && !isAnchor && campaignIsActive ? (
            (
              <React.Fragment>
                <FixedVideo
                  close={this.hideFixedVideo}
                  displayFixedVideo={displayFixedVideo}
                  homePage={true}
                  user={user}
                  videoImage={videoImage}
                />
                <Waypoint onEnter={this.hideFixedVideo} onLeave={this.displayFixedVideo}>
                  <div>
                    <PromoSection
                      backgroundColor={backgroundColor}
                      checkoutURL={checkoutUrl}
                      homePage={true}
                      isCampaignActive={true}
                      mainImage={mainImage}
                      mainMobileImage={mainMobileImage}
                      user={user}
                      videoControl={this.videoControl}
                    />
                  </div>
                </Waypoint>
              </React.Fragment>
            )
          ) : !isSubscriptionExpired || isAnchor ? (
            <VideoPlayer homePage={true} isProgram={true} user={user} />
          ) : (
            lastSegment && (
              <div
                className="homepageLockedVideo"
                style={{ overflow: 'auto' }}
              >
                <LockedVideo videoElement={lastSegment} />
              </div>
            )
          )}

        <FeaturedSection history={history} location={location} />
        <CoRegModal show={showCoRegModal} />
      </React.Fragment>
    );
  }
}

export default HomePage;
